module.exports = __webpack_public_path__ + "img/Second_image.27e0e58a.svg";